import { render } from "./isturCard.vue?vue&type=template&id=2aeec1a1"
import script from "./isturCard.vue?vue&type=script&lang=js"
export * from "./isturCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__